import React from "react";

import { Box } from "@material-ui/core";
import { FunctionField } from "react-admin";

/**
 * Shared ColorField component for displaying color swatches in lists/tables.
 * Uses FunctionField so react-admin passes record automatically. Remaining props are forwarded to FunctionField.
 *
 * @param {Object} props
 * @param {string} props.source - Field name on the record to read the color from (e.g. "color").
 * @param {string} [props.label="Color"] - Label for the field (e.g. "Color", "Account Color", "Product Color").
 * @returns {JSX.Element}
 */
export const ColorField = ({ source, label = "Color", ...props }) => (
  <FunctionField
    {...props}
    source={source}
    label={label}
    render={(record) => {
      const color = record?.[source];
      if (!color) return null;
      return (
        <Box
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid rgba(0,0,0,0.1)",
          }}
        />
      );
    }}
  />
);

ColorField.defaultProps = {
  addLabel: true,
};
